import React, { ReactElement } from 'react'
import { Card } from 'transfix-ui/components/Card'
import ShipmentIssues from 'apps/marketplace/pages/shipment-details/components/ShipmentIssues'

interface IIssues {
  shipmentId: string
}
const Issues = ({ shipmentId }: IIssues): ReactElement => {
  return (
    <div className='col-xs-12 col-md-12'>
      <Card title='Issues'>
        <div className='col-xs-12 col-md-12'>
          <ShipmentIssues shipmentId={shipmentId} readOnly />
        </div>
      </Card>
    </div>
  )
}

export default Issues
